import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files
const resources = {
  en: {
    translation: {
      welcome: "Welcome, {{username}}!",
      logout: "Logout",
      yourGames: "Your Games:",
      startNewGame: "Start a new game:",
      newGameDM: "New Game as Dungeon Master",
      newGame: "New Game",
      asPlayer: "as Player",
      imageStyle: "Image Style",
      voice: "Voice",
      language: "Language",
      aiModel: "AI Model",
      theme: "Theme",
      enchantedforestadventures: "Enchanted Forest Adventures",
      spaceexploration: "Space Exploration",
      piratetreasurehunt: "Pirate Treasure Hunt",
      knightanddragonfriend: "Knight and Dragon Friend",
      fairytalekingdom: "Fairy Tale Kingdom",
      untitled_story: "Untitled Story",
      alien: "Alien",
      cyberpunk: "Cyberpunk",
      darkfantasy: "Dark Fantasy",
      feudaljapansamurai: "Feudal Japan/Samurai",
      medievalfantasy: "Medieval Fantasy",
      mythologyfolklore: "Mythology/Folklore",
      piratehighseasadventure: "Pirate/High Seas Adventure",
      postapocalyptic: "Post-Apocalyptic",
      scifi: "Sci-Fi",
      spaceopera: "Space Opera",
      steampunk: "Steampunk",
      underwateradventure: "Underwater Adventure",
      vampire: "Vampire",
      western: "Western",
      zombie: "Zombie",
      your_role: "Your Role",
      ai_role: "AI Role",
      ai_model: "AI Model",
      players: "Players",
      player_name: "Player Name",
      add_player: "Add Player",
      image_style: "Image Style",
      back_to_game_list: "Back to Game List",
      error_submit_action: "Failed to submit action. Please try again.",
      generated_scene: "Generated scene",
      enter_action: "Enter your action or narrative", 
      submit_action: "Submit", 
      record: "Record",
      stop: "Stop",
      time_left: "Time Left",
      error_access_microphone: "Failed to access microphone. Please check your permissions.",
      error_speech_to_text: "Failed to convert speech to text. Please try again.",
      login: "Login",
      register: "Register",
      username: "Username",
      password: "Password",
      email: "Email",
      switch_to_register: "Switch to Register",
      switch_to_login: "Switch to Login",
      registration_successful: "Registration successful. Please log in.",
      registration_failed: "Registration failed",
      login_failed: "Login failed",
      title: "Title",
      ttsTrainingText: "The quick brown fox jumps over the lazy dog. Words flow naturally in speech.",
      invite_players: "Invite Players",
      share_link: "Share this link",
      or_invite_directly: "Or invite directly",
      role: "Role",
      player: "Player",
      observer: "Observer",
      cancel: "Cancel",
      invite: "Invite",
      online_players: "Online Players",
      server_down_message: "Server is currently unavailable. We're working on it!",
      login_with_fingerprint: "Login with Fingerprint"
    }
  },
  ptbr: {
    translation: {
      welcome: "Bem-vindo, {{username}}!",
      logout: "Sair",
      yourGames: "Seus Jogos:",
      startNewGame: "Iniciar um novo jogo:",
      newGameDM: "Novo Jogo como Mestre",
      newGame: "Novo Jogo",
      asPlayer: "como Jogador",
      imageStyle: "Estilo de Imagem",
      voice: "Voz",
      language: "Idioma",
      aiModel: "Modelo de IA",
      theme: "Tema",
      enchantedforestadventures: "Aventuras na Floresta Encantada",
      spaceexploration: "Exploração Espacial",
      piratetreasurehunt: "Caça ao Tesouro Pirata",
      knightanddragonfriend: "Cavaleiro e Dragão Amigo",
      fairytalekingdom: "Reino de Contos de Fadas",
      alien: "Alienígena",
      cyberpunk: "Cyberpunk",
      darkfantasy: "Fantasia Sombria",
      feudaljapansamurai: "Japão Feudal/Samurai",
      medievalfantasy: "Fantasia Medieval",
      mythologyfolklore: "Mitologia/Folclore",
      piratehighseasadventure: "Aventura Pirata/Alto Mar",
      postapocalyptic: "Pós-Apocalíptico",
      scifi: "Ficção Científica",
      spaceopera: "Ópera Espacial",
      steampunk: "Steampunk",
      underwateradventure: "Aventura Submarina",
      vampire: "Vampiro",
      western: "Faroeste",
      zombie: "Zumbi",
      untitled_story: "História Sem Título",
      your_role: "Seu Papel",
      ai_role: "Papel da IA",
      ai_model: "Modelo de IA",
      players: "Jogadores",
      player_name: "Nome do Jogador",
      add_player: "Adicionar Jogador",
      image_style: "Estilo de Imagem",
      back_to_game_list: "Voltar à Lista de Jogos",
      error_submit_action: "Falha ao enviar a ação. Por favor, tente novamente.",
      generated_scene: "Cena Gerada",
      enter_action: "Digite sua ação ou narrativa", 
      submit_action: "Enviar", 
      record: "Gravar",
      stop: "Parar",
      time_left: "Tempo Restante",
      error_access_microphone: "Falha ao acessar o microfone. Verifique suas permissões.",
      error_speech_to_text: "Falha ao converter fala para texto. Por favor, tente novamente.",
      login: "Entrar",
      register: "Registrar",
      username: "Nome de usuário",
      password: "Senha",
      email: "Email",
      switch_to_register: "Trocar para Registrar",
      switch_to_login: "Trocar para Entrar",
      registration_successful: "Registro bem-sucedido. Por favor, faça login.",
      registration_failed: "Falha no registro",
      login_failed: "Falha no login",
      title: "Título",
      ttsTrainingText: "A rápida raposa marrom salta sobre o cachorro preguiçoso. As palavras fluem na fala.",
      invite_players: "Convidar Jogadores",
      share_link: "Compartilhe este link",
      or_invite_directly: "Ou convide diretamente",
      role: "Função",
      player: "Jogador",
      observer: "Observador",
      cancel: "Cancelar",
      invite: "Convidar",
      online_players: "Jogadores Online",
      server_down_message: "O servidor está indisponível no momento. Estamos trabalhando nisso!",
      login_with_fingerprint: "Login com Impressão Digital"
    }
  },
  es: {
    translation: {
      welcome: "¡Bienvenido, {{username}}!",
      logout: "Cerrar sesión",
      yourGames: "Tus Juegos:",
      startNewGame: "Iniciar un nuevo juego:",
      newGameDM: "Nuevo Juego como Maestro",
      newGame: "Nuevo Juego",
      asPlayer: "como Jugador",
      imageStyle: "Estilo de Imagen",
      voice: "Voz",
      language: "Idioma",
      aiModel: "Modelo de IA",
      theme: "Tema",
      enchantedforestadventures: "Aventuras en el Bosque Encantado",
      spaceexploration: "Exploración Espacial",
      piratetreasurehunt: "Caza del Tesoro Pirata",
      knightanddragonfriend: "Caballero y Amigo Dragón",
      fairytalekingdom: "Reino de Cuentos de Hadas",
      alien: "Alienígena",
      cyberpunk: "Ciberpunk",
      darkfantasy: "Fantasía Oscura",
      feudaljapansamurai: "Japón Feudal/Samurái",
      medievalfantasy: "Fantasía Medieval",
      mythologyfolklore: "Mitología/Folclore",
      piratehighseasadventure: "Aventura Pirata/Alta Mar",
      postapocalyptic: "Post-Apocalíptico",
      scifi: "Ciencia Ficción",
      spaceopera: "Ópera Espacial",
      steampunk: "Steampunk",
      underwateradventure: "Aventura Submarina",
      vampire: "Vampiro",
      western: "Oeste",
      zombie: "Zombi",
      untitled_story: "Historia Sin Título",
      your_role: "Tu Papel",
      ai_role: "Papel de IA",
      ai_model: "Modelo de IA",
      players: "Jugadores",
      player_name: "Nombre del Jugador",
      add_player: "Añadir Jugador",
      image_style: "Estilo de Imagen",
      back_to_game_list: "Volver a la Lista de Juegos",
      error_submit_action: "No se pudo enviar la acción. Por favor, inténtelo de nuevo.",
      generated_scene: "Escena Generada",
      enter_action: "Ingresa tu acción o narrativa", 
      submit_action: "Enviar", 
      record: "Grabar",
      stop: "Detener",
      time_left: "Tiempo Restante",
      error_access_microphone: "No se pudo acceder al micrófono. Verifique sus permisos.",
      error_speech_to_text: "No se pudo convertir el discurso en texto. Por favor, inténtelo de nuevo.",
      login: "Iniciar sesión",
      register: "Registrar",
      username: "Nombre de usuario",
      password: "Contraseña",
      email: "Correo electrónico",
      switch_to_register: "Cambiar a Registro",
      switch_to_login: "Cambiar a Iniciar sesión",
      registration_successful: "Registro exitoso. Por favor, inicie sesión.",
      registration_failed: "Error en el registro",
      login_failed: "Error en el inicio de sesión",
      title: "Título",
      ttsTrainingText: "El rápido zorro marrón salta sobre el perro perezoso. Las palabras fluyen naturalmente.",
      invite_players: "Invitar Jugadores",
      share_link: "Compartir este enlace",
      or_invite_directly: "O invitar directamente",
      role: "Rol",
      player: "Jugador",
      observer: "Observador",
      cancel: "Cancelar",
      invite: "Invitar",
      online_players: "Jugadores en Línea",
      server_down_message: "El servidor está actualmente indisponible. Estamos trabajando en ello!",
      login_with_fingerprint: "Iniciar sesión con huella digital"
    }
  },
  de: {
    translation: {
      welcome: "Willkommen, {{username}}!",
      logout: "Abmelden",
      yourGames: "Deine Spiele:",
      startNewGame: "Neues Spiel starten:",
      newGameDM: "Neues Spiel als Dungeon Master",
      newGame: "Neues Spiel",
      asPlayer: "als Spieler",
      imageStyle: "Bildstil",
      voice: "Stimme",
      language: "Sprache",
      aiModel: "KI-Modell",
      theme: "Thema",
      enchantedforestadventures: "Abenteuer im Zauberwald",
      spaceexploration: "Weltraumerkundung",
      piratetreasurehunt: "Piraten-Schatzsuche",
      knightanddragonfriend: "Ritter und Drachenfreund",
      fairytalekingdom: "Märchenreich",
      alien: "Außerirdisch",
      cyberpunk: "Cyberpunk",
      darkfantasy: "Düstere Fantasie",
      feudaljapansamurai: "Feudales Japan/Samurai",
      medievalfantasy: "Mittelalterliche Fantasie",
      mythologyfolklore: "Mythologie/Folklore",
      piratehighseasadventure: "Piraten/Hochseeabenteuer",
      postapocalyptic: "Postapokalyptisch",
      scifi: "Science-Fiction",
      spaceopera: "Weltraumoper",
      steampunk: "Steampunk",
      underwateradventure: "Unterwasserabenteuer",
      vampire: "Vampir",
      western: "Western",
      zombie: "Zombie",
      untitled_story: "Unbenannte Geschichte",
      your_role: "Deine Rolle",
      ai_role: "KI-Rolle",
      ai_model: "KI-Modell",
      players: "Spieler",
      player_name: "Spielername",
      add_player: "Spieler hinzufügen",
      image_style: "Bildstil",
      back_to_game_list: "Zurück zur Spieleliste",
      error_submit_action: "Aktion konnte nicht gesendet werden. Bitte versuche es erneut.",
      generated_scene: "Generierte Szene",
      enter_action: "Gib deine Aktion oder Erzählung ein", 
      submit_action: "Absenden", 
      record: "Aufnehmen",
      stop: "Stoppen",
      time_left: "Verbleibende Zeit",
      error_access_microphone: "Zugriff auf Mikrofon fehlgeschlagen. Bitte überprüfe deine Berechtigungen.",
      error_speech_to_text: "Umwandlung von Sprache in Text fehlgeschlagen. Bitte versuche es erneut.",
      login: "Anmelden",
      register: "Registrieren",
      username: "Benutzername",
      password: "Passwort",
      email: "E-Mail",
      switch_to_register: "Zu Registrierung wechseln",
      switch_to_login: "Zu Anmeldung wechseln",
      registration_successful: "Registrierung erfolgreich. Bitte melde dich an.",
      registration_failed: "Registrierung fehlgeschlagen",
      login_failed: "Anmeldung fehlgeschlagen",
      title: "Titel",
      ttsTrainingText: "Der schnelle braune Fuchs springt über den faulen Hund. Wörter fließen natürlich.",
      invite_players: "Spieler einladen",
      share_link: "Diesen Link teilen",
      or_invite_directly: "Oder direkt einladen",
      role: "Rolle",
      player: "Spieler",
      observer: "Beobachter",
      cancel: "Abbrechen",
      invite: "Einladen",
      online_players: "Spieler Online",
      server_down_message: "Der Server ist derzeit nicht verfügbar. Wir arbeiten daran!",
      login_with_fingerprint: "Anmelden mit Fingerabdruck"
    }
  },
  it: {
    translation: {
      welcome: "Benvenuto, {{username}}!",
      logout: "Esci",
      yourGames: "I tuoi giochi:",
      startNewGame: "Inizia un nuovo gioco:",
      newGameDM: "Nuovo gioco come Dungeon Master",
      newGame: "Nuovo Gioco",
      asPlayer: "come Giocatore",
      imageStyle: "Stile dell'immagine",
      voice: "Voce",
      language: "Lingua",
      aiModel: "Modello AI",
      theme: "Tema",
      enchantedforestadventures: "Avventure nella Foresta Incantata",
      spaceexploration: "Esplorazione dello Spazio",
      piratetreasurehunt: "Caccia al Tesoro dei Pirati",
      knightanddragonfriend: "Cavaliere e Amico del Drago",
      fairytalekingdom: "Regno delle Fiabe",
      alien: "Alieno",
      cyberpunk: "Cyberpunk",
      darkfantasy: "Fantasy Oscuro",
      feudaljapansamurai: "Giappone Feudale/Samurai",
      medievalfantasy: "Fantasy Medievale",
      mythologyfolklore: "Mitologia/Folclore",
      piratehighseasadventure: "Avventura Pirata/Alto Mare",
      postapocalyptic: "Post-Apocalittico",
      scifi: "Fantascienza",
      spaceopera: "Space Opera",
      steampunk: "Steampunk",
      underwateradventure: "Avventura Sottomarina",
      vampire: "Vampiro",
      western: "Western",
      zombie: "Zombie",
      untitled_story: "Storia senza titolo",
      your_role: "Il tuo ruolo",
      ai_role: "Ruolo dell'AI",
      ai_model: "Modello AI",
      players: "Giocatori",
      player_name: "Nome del Giocatore",
      add_player: "Aggiungi Giocatore",
      image_style: "Stile dell'immagine",
      back_to_game_list: "Torna alla lista dei giochi",
      error_submit_action: "Impossibile inviare l'azione. Riprova.",
      generated_scene: "Scena Generata",
      enter_action: "Inserisci la tua azione o narrazione", 
      submit_action: "Invia", 
      record: "Registra",
      stop: "Ferma",
      time_left: "Tempo Rimasto",
      error_access_microphone: "Impossibile accedere al microfono. Controlla le autorizzazioni.",
      error_speech_to_text: "Impossibile convertire il discorso in testo. Riprova.",
      login: "Accedi",
      register: "Registrati",
      username: "Nome utente",
      password: "Password",
      email: "Email",
      switch_to_register: "Passa a Registrazione",
      switch_to_login: "Passa a Accesso",
      registration_successful: "Registrazione avvenuta con successo. Effettua il login.",
      registration_failed: "Registrazione fallita",
      login_failed: "Accesso fallito",
      title: "Titolo",
      ttsTrainingText: "Il rapido cane marrone salta sopra il volpe pigro. Le parole scorrono nel discorso.",
      invite_players: "Invita Giocatori",
      share_link: "Condividi questo link",
      or_invite_directly: "Oppure invita direttamente",
      role: "Ruolo",
      player: "Giocatore",
      observer: "Observatore",
      cancel: "Annulla",
      invite: "Invita",
      online_players: "Giocatori Online",
      server_down_message: "Il server è attualmente indisponibile. Stiamo lavorando su questo!",
      login_with_fingerprint: "Accedi con la tua impronta digitale"
    }
  },
  fr: {
    translation: {
      welcome: "Bienvenue, {{username}}!",
      logout: "Se déconnecter",
      yourGames: "Vos jeux:",
      startNewGame: "Commencer un nouveau jeu:",
      newGameDM: "Nouveau jeu en tant que Maître du Donjon",
      newGame: "Nouveau Jeu",
      asPlayer: "comme Joueur",
      imageStyle: "Style d'image",
      voice: "Voix",
      language: "Langue",
      aiModel: "Modèle IA",
      theme: "Thème",
      enchantedforestadventures: "Aventures dans la Forêt Enchantée",
      spaceexploration: "Exploration Spatiale",
      piratetreasurehunt: "Chasse au Trésor Pirate",
      knightanddragonfriend: "Chevalier et Ami du Dragon",
      fairytalekingdom: "Royaume des Contes de Fées",
      alien: "Extraterrestre",
      cyberpunk: "Cyberpunk",
      darkfantasy: "Fantasy Sombre",
      feudaljapansamurai: "Japon Féodal/Samouraï",
      medievalfantasy: "Fantasy Médiévale",
      mythologyfolklore: "Mythologie/Folklore",
      piratehighseasadventure: "Aventure Pirate/Haute Mer",
      postapocalyptic: "Post-Apocalyptique",
      scifi: "Science-Fiction",
      spaceopera: "Opéra Spatial",
      steampunk: "Steampunk",
      underwateradventure: "Aventure Sous-Marine",
      vampire: "Vampire",
      western: "Western",
      zombie: "Zombie",
      untitled_story: "Histoire sans titre",
      your_role: "Votre rôle",
      ai_role: "Rôle de l'IA",
      ai_model: "Modèle IA",
      players: "Joueurs",
      player_name: "Nom du Joueur",
      add_player: "Ajouter un Joueur",
      image_style: "Style d'image",
      back_to_game_list: "Retour à la liste des jeux",
      error_submit_action: "Impossible d'envoyer l'action. Veuillez réessayer.",
      generated_scene: "Scène Générée",
      enter_action: "Entrez votre action ou narration", 
      submit_action: "Soumettre", 
      record: "Enregistrer",
      stop: "Arrêter",
      time_left: "Temps restant",
      error_access_microphone: "Échec de l'accès au microphone. Veuillez vérifier vos autorisations.",
      error_speech_to_text: "Échec de la conversion de la parole en texte. Veuillez réessayer.",
      login: "Connexion",
      register: "S'inscrire",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      email: "Email",
      switch_to_register: "Passer à l'inscription",
      switch_to_login: "Passer à la connexion",
      registration_successful: "Inscription réussie. Veuillez vous connecter.",
      registration_failed: "Échec de l'inscription",
      login_failed: "Échec de la connexion",
      title: "Titre",
      ttsTrainingText: "Le renard brun rapide saute par-dessus le chien paresseux. Les mots coulent naturellement.",
      invite_players: "Inviter des Joueurs",
      share_link: "Partager ce lien",
      or_invite_directly: "Ou inviter directement",
      role: "Rôle",
      player: "Joueur",
      observer: "Observateur",
      cancel: "Annuler",
      invite: "Inviter",
      online_players: "Joueurs en Ligne",
      server_down_message: "Le serveur est actuellement indisponible. Nous y travaillons!",
      login_with_fingerprint: "Se connecter avec votre empreinte digitale"
    }
  }
  // Add translations for other languages here
};

i18n
  .use(initReactI18next) // Connects i18n with React
  .init({
    resources,
    lng: "ptbr", // Default language
    fallbackLng: "ptbr",
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n;
